import { BaseService } from "@/services/BaseService";

export interface AccountProfile {
  id: string;
  emailHash?: string;
  status?: string;
  openIdUserId?: string;
  lastLogin?: string;
  createdAt?: string;
  updatedAt?: string;
  tenantId?: string;
  role?: string;
  profile?: {
    id?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    address?: string;
    language?: string;
    preferredLanguage?: string;
    hotelId?: string;
    tenantId?: string;
    dateOfBirth?: string;
    photoId?: string;
  } | null;
}

export interface UpdateSelfProfileDto {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  language?: string;
  preferredLanguage?: string;
  address?: string;
  photoId?: string;
}

class AccountProfileService extends BaseService {
  private basePath = "/profile";

  async getProfile(): Promise<AccountProfile> {
    return this.get<AccountProfile>("/auth/me", undefined, {
      skipSelectedHotelHeader: true,
    });
  }

  async updateProfile(
    data: UpdateSelfProfileDto,
  ): Promise<{ message: string }> {
    return this.patch<{ message: string }>(this.basePath, data);
  }
}

export const accountProfileService = new AccountProfileService();
